module.exports = __webpack_public_path__ + "cr.1301db57288447b6667a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/cr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/cr.svg
// module chunks = styles